$(document).ready(function () {
  function initSelect2() {
    $('.js-pet-select').select2({
      placeholder: "サブメインペットを選択してください。",
      allowClear: true,
      templateResult: function (state) {
        if (!state.id) return state.text;
        const imageUrl = $(state.element).data('image');
        return $(
          '<span><img src="' + imageUrl + '" style="width: 60px; height: 60px; object-fit: cover; border-radius: 10%; margin-right: 8px;"> ' +
          state.text + '</span>'
        );
      },
      templateSelection: function (state) {
        if (!state.id) return state.text;
        const imageUrl = $(state.element).data('image');
        return $(
          '<span><img src="' + imageUrl + '" style="width: 60px; height: 60px; object-fit: cover; border-radius: 10%; margin-right: 6px;"> ' +
          state.text + '</span>'
        );
      }
    });
  }

  function cacheOriginalOptions($select) {
    if (!$select.data('original-options')) {
      $select.data('original-options', $select.find('option').clone());
    }
  }

  function updateSelectOptions() {
    const $main = $('#main_pet_select');
    const $other = $('#pet_select');

    const mainSelected = $main.val();
    const otherSelected = $other.val();

    cacheOriginalOptions($main);
    cacheOriginalOptions($other);

    $main.empty();
    $main.data('original-options').each(function () {
      const val = $(this).val();
      if (!otherSelected || val === '' || val === mainSelected || val !== otherSelected) {
        $main.append($(this).clone());
      }
    });
    $main.val(mainSelected).trigger('change.select2');

    $other.empty();
    $other.data('original-options').each(function () {
      const val = $(this).val();
      if (!mainSelected || val === '' || val === otherSelected || val !== mainSelected) {
        $other.append($(this).clone());
      }
    });
    $other.val(otherSelected).trigger('change.select2');
  }

  $('#main_pet_select, #pet_select').on('change', function () {
    updateSelectOptions();
  });

  initSelect2();
  updateSelectOptions();
});
